import React from 'react';
import styles from '../Operations.module.css';

interface OSATComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

const OSAT: OSATComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>
      <div className={styles.sectionContent}>
        <strong>What makes up an OSAT Score:</strong>
        <br /><br />
        The OSAT &quot;Top Box&quot; Score is based on how many customers rate a &quot;Top Box&quot; Score of 5 out of 5 for their overall customer experience. The score is based on one question on the survey — &quot;Please rate your satisfaction with your overall experience at our store&quot; — and takes into consideration the whole customer experience from the moment the customer walks in our doors up until checkout.
        <br /><br />
        <strong>Example: </strong>
        Ace surveyed 381,515 customers, with 82.2% of those surveyed giving us a score of 5 out of 5 for the question: &quot;Please rate your satisfaction with your overall experience at our store.&quot; Our overall Ace Hardware OSAT Score is 82.2% because 82.2% of 381,515, or 313,605, customers rated Ace over all a 5 out of 5, meaning they were &quot;Extremely Satisfied&quot;.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>
      <div className={styles.sectionContent}>
        Find more information on:{' '}
        <a
          href="https://acenet.aceservices.com/awor/helpful-customer-service/customer-first-culture"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          Acenet &gt; AWOR &gt; Helpful Experience &gt; Measure Helpful
        </a>
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>
      <div className={styles.sectionContent}>
        <strong>Platinum</strong> - Within the Rolling 12 months, 80 or more Customer Engagement Surveys with an OSAT score of = <strong>80% - 84.9%</strong>
        <br /><br />
        <strong>Pinnacle </strong>- Within the Rolling 12 months, 80 or more Customer Engagement Surveys with an OSAT score of = <strong>85%</strong>
        <br /><br />
        <strong><u>Drill Down</u></strong>
        <br />
        Use the Dashboard to take a deeper dive into your Survey, Mystery Shop Data, Customer Journey, BOPIS and Curbside data.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        1. Use the{' '}
        <a
          href="https://mydigimag.rrd.com/publication/?m=55555&l=1&p=&pn="
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          OSAT Playbook
        </a>{' '}
        to put prescriptive measures in place to bring your score up.
        <br />
        2. Click on the key driver opportunity and be taken to specific options for prescriptive plans to put in place for that particular driver to raise your OSAT score!
      </div>
    </div>
  );
};

OSAT.title = 'OSAT (Overall Customer Satisfaction) Customer Engagement';
OSAT.actionTitle = 'Review Medallia Dashboard';
OSAT.actionHyperlink = 'https://acehardware.medallia.com/sso/acehardware';
export default OSAT;

